//src/pages/PostPage.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import api from "../api";
import PostCard from "../components/PostCard";
import CommentsDrawer from "../components/CommentsDrawer";

export default function PostPage() {
  const { id } = useParams();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function loadPost() {
      try {
        const { data } = await api.get(`/posts/${id}`);

if (mounted) {
  setPost(data.post);
}

const isClip =
  data.post.type === "clip" ||
  data.post.post_type === "clip" ||
  data.post.is_clip === true;

if (!isClip) {
  try {
    const { data: viewData } = await api.post(`/posts/${id}/view`);

    if (mounted && typeof viewData.view_count === "number") {
      setPost(prev => ({
        ...prev,
        view_count: viewData.view_count,
      }));
    }
  } catch (_) {}
}



      } catch (err) {
        console.error(err);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    }

    loadPost();

    return () => {
      mounted = false;
    };
  }, [id]);
  
  if (loading) return <div>Loading…</div>;

if (!post) return <div>Post not found.</div>;

  return (
  <div
    style={{
      height: "100dvh",
      display: "flex",
      flexDirection: "column",
      background: "#000",
    }}
  >
    <div
      style={{
        flexShrink: 0,
        overflowY: "auto",
      }}
    >
      <PostCard
  p={post}
  detailView
  onViewCount={(count) =>
    setPost(prev => ({
      ...prev,
      view_count: count,
    }))
  }
  onSupport={() => {}}
  onRepost={() => {}}
  onShare={() => {}}
/>
    </div>

    <div
      style={{
        flex: 1,
        minHeight: 0,
      }}
    >
      <CommentsDrawer
        inline
        open
        onClose={() => {}}
        target={{
          id: post.id,
          author_id: post.author_id,
        }}
      />
    </div>
  </div>
);
  
}